import React from "react";
import { Button, Input, Select } from "antd";
import style from "./index.module.scss";
import Form, { useForm } from "rc-field-form";
import useRequest from "utils/useRequest";
import { CopyListParams, getCourseInfo } from "service/group";
import Config from "../../../../../../config";
import Storage from "utils/Storage";

interface FormData {
    courseInfo: string[];
    keyword: string;
}

const Index = ({ onSearch }: { onSearch: (val: CopyListParams) => void }) => {
    const [form] = useForm<FormData>();
    const { Option } = Select;
    const batchNo: string = Storage.get("batch") || Config.DefaultBatch;
    const customerCode = Config.CustomCode;

    const [courseInfo] = useRequest(getCourseInfo);

    async function onFinish(data: FormData) {
        console.log(data);
        const courseInfo = data.courseInfo.map(item => ({
            courseNo: item.split("-")[0],
            courseSeq: item.split("-")[1],
            customerCode,
            batchNo
        }));

        onSearch({ keyword: data.keyword, queryParams: courseInfo });
    }
    return (
        <div className={style.root}>
            <Form form={form} onFinish={onFinish} className={style.form}>
                <div className={style.course}>
                    <div className={style.label}>课程信息：</div>

                    <Form.Field name="courseInfo" initialValue={[]}>
                        <Select
                            mode="multiple"
                            className={style.select}
                            placeholder="请选择课程"
                            maxTagCount={1}
                            allowClear
                            showArrow>
                            {courseInfo?.map(item => (
                                <Option
                                    value={`${item.courseno}-${item.courseseq}`}
                                    key={item.id}>
                                    [{item.courseno} - {item.courseseq}]&nbsp;
                                    {item.coursename}
                                </Option>
                            ))}
                        </Select>
                    </Form.Field>
                </div>
                <div className={style.search}>
                    <Form.Field name="keyword" initialValue={""}>
                        <Input
                            maxLength={200}
                            placeholder="请输入小组活动名称关键词"
                        />
                    </Form.Field>
                    <Button type="primary" icon="search" onClick={form.submit}>
                        查询
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default Index;
